import { createFileRoute, Navigate } from '@tanstack/react-router';
import { TEAMS_ENABLED } from '../../features/teams/teamsEnabled';
import { TeamMembersPage } from '../../pages/dashboard/team/TeamMembersPage';

export const Route = createFileRoute('/dashboard/team')({ component: TeamRoute });

/** With Teams off there is no Team page, so the address is the dashboard. */
function TeamRoute() {
  return TEAMS_ENABLED ? <TeamMembersPage /> : <Navigate to="/dashboard" replace />;
}
